export function RequiredIndicator() {
  return (
    <span
      role="presentation"
      aria-hidden="true"
      style={{ marginInlineStart: "0.25rem", color: "var(--chakra-colors-red-500)" }}
    >
      *
    </span>
  );
}
